document.addEventListener('click', (e) => {
    const btn = e.target.closest('.testimony-read-more');

    if (!btn) {
        return;
    }

    e.preventDefault();

    const text = btn.previousElementSibling;

    if (btn.classList.contains('is-open')) {
        text.textContent = text.dataset.short;
        btn.textContent = btn.dataset.openLabel;
        btn.classList.remove('is-open');
    } else {
        text.textContent = text.dataset.full;
        btn.textContent = btn.dataset.closeLabel;
        btn.classList.add('is-open');
    }
});